<template>
  <div class="bg-surface-raised flex flex-col gap-2 rounded border p-2">
    <div>
      <h4 class="truncate leading-none font-bold">
        {{ recipient.name }}
      </h4>
      <div v-if="recipient.type !== 'App\\Models\\Supplier'">
        <span
          v-for="(extra, idx) in recipient.extra"
          :key="idx"
          :data-tint="extra.tint"
          class="bg-primary text-contrast-primary text-xxs rounded px-1"
        >
          {{ extra.value }}
        </span>
      </div>
      <div class="truncate text-xs text-slate-500">
        {{ recipient.emailable }}
      </div>
    </div>
    <div class="flex flex-row justify-end gap-1 text-xs">
      <button
        class="bg-primary text-contrast-primary rounded border px-1 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-700"
        :disabled="disabled"
        @click="$emit('add-to-to', recipient)"
      >
        {{ $t('global.email_to') }}
      </button>
      <button
        class="bg-primary text-contrast-primary rounded border px-1 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-700"
        :disabled="disabled"
        @click="$emit('add-to-cc', recipient)"
      >
        {{ $t('global.email_cc') }}
      </button>
      <button
        class="bg-primary text-contrast-primary rounded border px-1 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-700"
        :disabled="disabled"
        @click="$emit('add-to-bcc', recipient)"
      >
        {{ $t('global.email_bcc') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecipientCard',
  props: {
    recipient: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['add-to-to', 'add-to-cc', 'add-to-bcc']
}
</script>

<style scoped></style>
